module.exports = __webpack_public_path__ + "img/chicken-bbq.c4bc6e1c.jpg";